export const GET_REPORT_LOGS = "/reports/logs";
export const DELETE_REPORT_LOGS = "/reports/deleteLog";
